import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppScopeStore } from '@frontend/scope';
import { DropdownField, SearchField, useControlledField, useDebouncedFn } from '@frontend/design-system';
import { styles } from '../steps/styles';
import { useValidateUsersShallowStore } from '../stores/validate-users-store';
import { FilterKeys, FilterValues } from './types';

type FiltersType = {
  onChange: (type: FilterKeys, value: FilterValues[FilterKeys]) => void;
  hideLocation?: boolean;
  useNewApi?: boolean;
};
export const Filters = ({ onChange, hideLocation, useNewApi }: FiltersType) => {
  const { t } = useTranslation('payments');
  const { getLocationName, selectedLocationIds: locations } = useAppScopeStore();
  const { setFilters } = useValidateUsersShallowStore('setFilters');

  const [searchValue, setSearchValue] = useState('');
  const [selectedLocation, setSelectedLocation] = useState(locations.length > 0 ? locations[0] : '');

  const onSearchChange = useDebouncedFn((value) => {
    if (useNewApi) {
      setFilters({ searchValue: value });
    } else {
      onChange('textSearch', value);
    }
  }, 300);

  const globalSearch = useControlledField({
    type: 'text',
    onChange: (val) => {
      setSearchValue(val);
      onSearchChange(val);
    },
    value: searchValue,
  });

  const locationField = useControlledField({
    type: 'dropdown',
    required: true,
    onChange: ({ value }) => {
      setSelectedLocation(value);
      if (useNewApi) {
        setFilters({ location: value });
      } else {
        onChange('location', value);
      }
    },
    value: selectedLocation,
  });

  return (
    <div css={styles.filters.filterContainer}>
      {!hideLocation && (
        <div css={locations.length <= 1 ? styles.filters.camouflage : undefined}>
          <DropdownField {...locationField} label='' name='location'>
            {locations.map((location) => (
              <DropdownField.Option key={location} value={location}>
                {getLocationName(location)}
              </DropdownField.Option>
            ))}
          </DropdownField>
        </div>
      )}
      <SearchField
        placeholder={t('Search')}
        name='bulkCreateModalglobalSearch'
        data-trackingid='bulkCreateModalglobalSearch'
        css={styles.filters.searchField}
        {...globalSearch}
      />
    </div>
  );
};
